import React from 'react';
import _ from 'lodash';

// s3
import { audioURL } from 'config';

// redux
import { useSelector } from 'react-redux';

export default function useGetStringAudio(localeOverride) {
  const { 
    strings, locales, 
    currentActivity, editingActivity, 
    solutionLocale 
  } = useSelector((state) => ({
    currentActivity: state.game.currentActivity,
    editingActivity: state.flinkMake.activity.editingActivity,
    solutionLocale: state.flinkPlay.solutionLocale || state.status.lang,
    strings: state.common.strings,
    locales: state.common.locales,
  }));

  const locale = React.useMemo(() => {
    const isEdit = typeof window !== 'undefined'
      && window.location?.href?.includes('edit-activities');

    const candidatesRaw = [
      localeOverride,
      solutionLocale?.code,
      isEdit ? editingActivity?.activity?.currentLanguageVersion?.locale : null,
      currentActivity?.activity?.locale,
      editingActivity?.activity?.locale,
    ];
    const candidates = candidatesRaw
      .map(v => (typeof v === 'string' ? v.trim() : ''))
      .filter(Boolean);

    const code = candidates[0] || 'en';

    const found =
      _.find(locales, { code }) ||
      _.find(locales, { code: 'en' }) ||
      locales?.[0];

    if (process?.env?.NODE_ENV !== 'production') {
      console.debug('useGetStringAudio: locale candidates -> chosen', {
        candidates, chosen: found?.code || 'en'
      });
    }

    return found || { code: 'en', name: 'en' };
  }, [
    locales,
    localeOverride,
    solutionLocale?.code,
    currentActivity?.activity?.locale,
    editingActivity?.activity?.locale,
    editingActivity?.activity?.currentLanguageVersion?.locale
  ]);

  return React.useCallback((stringNumber, getFullPath = false) => {
    const search = _.find(strings, { stringNumber: +stringNumber });

    if (process?.env?.NODE_ENV !== 'production') {
  console.debug('[useGetStringAudio] keys', {
    stringNumber: +stringNumber,
    code: locale?.code, name: locale?.name,
    codeKeys: Object.keys(_.get(search, ['data', locale?.code], {})),
    nameKeys: Object.keys(_.get(search, ['data', locale?.name], {})),
  });
}


    const localeName = locale?.name || locale?.code || 'en';
    const localeCode = locale?.code || 'en';

    const path = getFullPath
      ? `${audioURL}/Generic/Strings/${localeName}/`
      : `Audio/Generic/Strings/${localeName}/`;

    const audio = _.get(search, `data.${localeCode}.stringAudio`);

  /*  const audio =
  _.get(search, ['data', localeCode, 'stringAudio']) ??
  _.get(search, ['data', localeCode, 'audio']) ??
  _.get(search, ['data', locale?.name, 'stringAudio']) ??
  _.get(search, ['data', locale?.name, 'audio']) ??
  null;*/

    try {
      const ensureSlash = p => (p && p.endsWith('/') ? p : `${p}/`);
      const fullUrl = audio ? `${ensureSlash(path)}${audio}` : null;

      if (typeof console !== 'undefined' && process?.env?.NODE_ENV !== 'production') {
        console.debug('[useGetStringAudio] audio path', {
          stringNumber: +stringNumber,
          localeCode,
          path,                 
          audio: audio || null, 
          fullUrl,              
          getFullPath,
        });
      }
    } catch (e) {
      console.warn('[useGetStringAudio] log error', e);
    }

    return { stringNumber, audio, path };
  }, [strings, locale]);
}
